import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import slugify from "../utils/slugify";
import Breadcrumb from "../components/Breadcrumb";
import { useTranslation } from "react-i18next";

function Composers() {
  const [composers, setComposers] = useState([]);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Decorative title function (must be before return)
  const formatTitle = (title) => {
    if (!title) return null;
    return title.split(" ").map((word, wordIndex) => (
      <span key={wordIndex}>
        <span className="font-cinzel-important">{word.charAt(0)}</span>
        <span className="font-cinzel-important">{word.slice(1)}</span>
        {wordIndex < title.split(" ").length - 1 && " "}
      </span>
    ));
  };

  // Smart image positioning based on aspect ratio
  const handleSmartImageLoad = (e) => {
    const img = e.target;
    const ratio = img.naturalWidth / img.naturalHeight;

    // Only apply special positioning for tall portrait images (ratio < 1)
    if (ratio < 1) {
      const className = img.className;
      if (className.includes("h-[400px]")) {
        img.style.objectPosition = "center 8%"; // Card images
      }
    }
    // Square and landscape images keep default center positioning
  };

  useEffect(() => {
    axios
      .get("/api/composers")
      .then((res) => {
        const sortedComposers = [...res.data]
          ?.filter((a) => a.published === true)
          ?.sort((a, b) => a.name.localeCompare(b.name));
        setComposers(sortedComposers);
      })
      .catch((err) => console.log("Error fetching composers:", err));
  }, []);
  const { t } = useTranslation();
  return (
    <div className="bg-white">
      <div className="relative w-full h-[280px] lg:h-[33vw] overflow-hidden">
        <img
          src="/images/composers-hero.jpg"
          alt={t("Composers.explore")}
          className="w-full h-full object-cover object-[50%_30%] sm:object-[50%_37%] lg:object-[50%_38%]"
          onLoad={() => setImageLoaded(true)}
        />
        {imageLoaded && (
          <div className="absolute mt-20 md:mt-40 inset-0 flex flex-col items-center justify-center p-4 text-center">
            <h1
              className="text-2xl md:text-5xl lg:text-7xl mb-2 text-white font-cormorant-garamond font-medium"
              style={{
                textShadow: "1.5px 2px  rgba(0,0,0)",
              }}
            >
              {t("Composers.hero")} <br /> {t("Composers.hero2")}
            </h1>
          </div>
        )}
      </div>
      <Breadcrumb
        items={[
          { href: "/", label: "Home" },
          {
            href: "/composers",
            label: "Composers",
          },
        ]}
      />
      <main className="max-w-[1140px] mx-auto py-8 px-4 flex flex-col items-center">
        <div>
          <h1 className="text-3xl text-start mb-8">
            {t("Composers.composers")}
          </h1>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
            {composers.map((composer) => (
              <Link
                key={composer._id}
                to={`/composers/${slugify(composer.name)}`}
                className="no-underline text-inherit"
              >
                <div className="w-[175px] 2xs:w-[210px] xs:w-[270px] sm:w-[308px] md:w-[343px] lg:w-[210px] xl:w-[265px] lg:h-[323px] xl:h-[373px] shadow-md border border-black-300 overflow-hidden flex flex-col hover:scale-[1.01] transition-transform">
                  {composer.image ? (
                    <img
                      src={composer.image}
                      alt={composer.name}
                      className="w-full h-[175px] 2xs:h-[210px] xs:h-[270px] sm:h-[308px] md:h-[343px] lg:h-[210px] xl:h-[265px] object-cover"
                      onLoad={handleSmartImageLoad}
                    />
                  ) : (
                    <div className="w-full h-[175px] 2xs:h-[210px] xs:h-[270px] sm:h-[308px] md:h-[343px] lg:h-[210px] xl:h-[265px] bg-white flex items-center justify-center text-black text-base"></div>
                  )}
                  <div className="flex flex-col flex-1 justify-between p-4">
                    <h3 className="text-xs 2xs:text-lg lg:text-sm xl:text-lg text-black font-cinzel-important uppercase text-left">
                      {composer.name}
                    </h3>
                    <span className="bg-black text-[#DFDFDF] mt-2 px-4 py-2 text-sm rounded inline-block hover:text-white transition-colors self-start">
                      {t("Composers.more")}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

export default Composers;
